export default function(state={formData:{}}, action) {

    switch(action.type) {
        case "FORM_DATA":
            return {
                formData: {
                    ...state.formData,
                    [action.payload.Name]: action.payload.Value
                }
            };

        case "RESET_FORM":
            return {
                formData: {}
            };

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerFormData.js